import React from "react";
import { Cmr } from "../../../../models/Cmr";
import Delete from "./delete";
import Edit from "./edit";
import Pdf from "./pdf";

interface Props {
  entity: Cmr;
}

const Actions: React.FC<Props> = ({ entity }) => {
  return (
    <>
      <Pdf id={entity.id} />
      <Edit id={entity.id} />
      <Delete id={entity.id} />
    </>
  );
};

export default Actions;
